import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { Task } from '@shared/models/task.model';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { ChangesSidenavController } from '@shared/modules/task-sidenav/controllers/changes-sidenav.controller';
import { TaskController } from '@shared/controllers/task.controller';
import { ListService } from '@shared/modules/list/services/list.service';
import { SnackBarService } from '@core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { Project } from '@modules/projects/shared/models/project.model';
import { ProjectChangesService } from '@modules/projects/modules/project-changes/shared/services/project-changes.service';
import { ProjectChangesStatus } from '@modules/projects/shared/enums/project-changes-status.enum';
import { RemoveModalController } from '@shared/controllers/remove-modal.controller';

@Component({
  selector: 'changes-toggle-cell',
  templateUrl: './changes-toggle-cell.component.html',
  styleUrls: ['./changes-toggle-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangesToggleCellComponent implements OnInit, ListCustomCell {
  @ViewChild('template') template;
  row: Task | null = null;

  private readonly listService = inject(ListService);
  private readonly s = inject(SnackBarService);
  private readonly t = inject(TranslateService);
  private readonly changesService = inject(ProjectChangesService);

  ngOnInit(): void {}

  preview() {
    const ctrl = new ChangesSidenavController();
    const row = this.row;
    ctrl.previewChange(row?.taskId || String(row?.id));
  }

  edit() {
    const ctrl = new ChangesSidenavController();
    const row = this.row;
    ctrl.editChange(row?.project?.id, row?.taskId || String(row?.id));
  }

  share() {
    const row = this.row;
    const shareData = () => {
      const ctrl = new ChangesSidenavController();
      const project = row?.project ? new Project(row?.project) : null;
      ctrl.shareSingleChange(row, row?.project?.id, project);
    };

    if (row?.changeStatus === ProjectChangesStatus.CHANGE_STATUS_SETTLED) {
      const ctrl = new TaskController(row);
      ctrl.askForShare(row).then(() => {
        shareData();
      });
    } else {
      shareData();
    }

    // const sub = ctrl.shareSingleChange(this.row, this.row.project?.id, project).subscribe(() => {
    //   sub.unsubscribe();
    // });
  }

  createTask() {
    const ctrl = new ChangesSidenavController();
    const row = this.row;
    ctrl.taskCreate(row?.id, row?.project?.id);
  }

  objectCreatorId() {
    const row = this.row;
    if (row) {
      return [row?.creator?.id, ...row?.assignedTo.map((e) => e.id)];
    }
  }

  remove() {
    const row = this.row;
    const ctrl = new RemoveModalController();
    ctrl
      .remove(() => {
        const _ctrl = new TaskController(row);
        _ctrl.removeTask(row).subscribe({
          next: () => {
            this.listService.getRows();
            this.changesService.updateEmitter.emit(true);
            this.s.success(this.t.instant('ProjectChanges.List.changeRemoved'));
          },
          error: () => {
            this.s.defaultError();
          }
        });
      })
      .subscribe(() => {});
  }
}
